import React from 'react'
import {Header} from '../header/Header'
import {PageFooter} from '../footer/PageFooter'
import {SignInPage} from './SignInPage'

const SignInPageContainer: React.FC = () => {
  return (
    <div className={'main-layout'}>
      <Header />
      <div className={'main-content'}>
        <SignInPage />
      </div>
      <PageFooter />
    </div>
  )
}

export {SignInPageContainer}
